import PropTypes from "prop-types";
import * as React from "react";
import { TextInput } from "../../../themeV2";

export default function CharityField({ value, onChange }) {
  return (
    <TextInput
      value={value}
      onChange={(e) => onChange(e.target.value)}
      description="If the shop donates 100% of proceeds to a charity, enter the name here. This will show the Charity Badge on the shop page."
      style={{ maxWidth: "52ch" }}
    />
  );
}

CharityField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
